const NAME_PATTERN = /^[a-z0-9_-]+$/;
const MAX_NAME_LENGTH = 64;
const MAX_PARAM_LENGTH = 64;
const MAX_VALUE_LENGTH = 255;
const MAX_PARAMS = 10;

const normalizeGoalName = (name) => {
  const normalized = String(name || "").trim().toLowerCase();
  if (!normalized || normalized.length > MAX_NAME_LENGTH) return "";
  if (!NAME_PATTERN.test(normalized)) return "";
  return normalized;
};

const normalizeParams = (params) => {
  if (!params || typeof params !== "object") return null;
  const entries = Object.entries(params);
  if (!entries.length) return null;
  const output = {};
  let count = 0;

  for (const [rawKey, rawValue] of entries) {
    if (count >= MAX_PARAMS) break;
    const key = String(rawKey || "").trim().toLowerCase();
    if (!key || key.length > MAX_PARAM_LENGTH || !NAME_PATTERN.test(key)) continue;
    if (rawValue === undefined || rawValue === null) continue;
    let value = String(rawValue);
    if (!value) continue;
    if (value.length > MAX_VALUE_LENGTH) value = value.slice(0, MAX_VALUE_LENGTH);
    output[key] = value;
    count += 1;
  }

  return count ? output : null;
};

export const trackGoal = (name, params) => {
  if (typeof window === "undefined") return false;
  const goal = normalizeGoalName(name);
  if (!goal) return false;
  const payload = normalizeParams(params);
  try {
    if (payload) {
      window.datafast?.(goal, payload);
    } else {
      window.datafast?.(goal);
    }
    return true;
  } catch (_err) {
    return false;
  }
};
